import React from 'react';
import IsRequired from '../common/IsRequired';
import HelpBlock from '../common/HelpBlock';
import { defaultContentCssClass, defaultLabelCssClass } from '../../consts/consts';
/*
 * Custom hook to apply some style-based attributes to form field components.
 */
const useFieldDecorators = ({ isRequired, helpBlock, contentCssClass, labelCssClass, errors, touched, labelDangerOnError, }) => {
    const isRequiredBlock = isRequired ? React.createElement(IsRequired, null) : null;
    const helpTextBlock = helpBlock ? React.createElement(HelpBlock, { helpText: helpBlock }) : null;
    const isErrorField = errors && touched;
    return {
        isRequired: isRequiredBlock,
        helpBlock: helpTextBlock,
        contentCssClass: contentCssClass || defaultContentCssClass,
        labelCssClass: `${labelCssClass || defaultLabelCssClass} ${isErrorField && labelDangerOnError ? 'text-danger' : ''}`,
        fieldCssClass: `form-control ${isErrorField ? 'is-invalid' : ''}`,
    };
};
export default useFieldDecorators;
